import { render, staticRenderFns } from "./ElTableColumnSortable.vue?vue&type=template&id=4f63321e"
import script from "./ElTableColumnSortable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ElTableColumnSortable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports